import { createRecipe } from './runtime';

const wipBadgeConfig = {"name":"wipBadge","variantMap":{"overlay":["true"]}}

export const wipBadge = /* @__PURE__ */ createRecipe(wipBadgeConfig)